export * from './doctor.interface';
